import { useStore } from 'effector-react'
import { NewTinkoffPay, TinkoffPay } from '~/widgets/TinkoffPay'
import { payModel } from '~/entities/Balance'
import { CURRENCY } from '~/shared/config/constants'
import { featureFlagModel } from '~/shared/lib/featureFlag'
import { DrawerComponent } from '~/shared/ui/Drawer'
import { DetailAmountTitle, DetailBlock, DetailItemTitle } from './styled'

type ConfirmPayDrawerProps = {
  isShow: boolean
  onClose: () => void
}

const getSum = (value: unknown) =>
  typeof value === 'number' ? value.toLocaleString() : '-'

export function ConfirmPayDrawer({ isShow, onClose }: ConfirmPayDrawerProps) {
  const featureFlags = useStore(featureFlagModel.$featureFlags)
  const commission = useStore(payModel.$payCommission)
  const amount = commission?.amount

  return (
    <DrawerComponent isShow={isShow} onCancel={onClose}>
      <div style={{ textAlign: 'center', marginBottom: '44px' }}>
        <div style={{ fontSize: '12px' }}>Итоговая сумма начисления</div>
        <div
          style={{ fontSize: '32px', fontWeight: '500' }}
          data-testid='confirm-pay-amount-total'
        >
          {getSum(commission?.amountTotal)} {CURRENCY}
        </div>
      </div>

      <div style={{ fontSize: '16px', marginBottom: '16px' }}>Детали:</div>
      <DetailBlock style={{ marginBottom: '8px' }}>
        <DetailItemTitle>Сумма с комиссией</DetailItemTitle>
        <DetailAmountTitle data-testid='confirm-pay-amount'>
          {getSum(amount)} {CURRENCY}
        </DetailAmountTitle>
      </DetailBlock>
      <DetailBlock style={{ marginBottom: '44px' }}>
        <DetailItemTitle>Комиссия</DetailItemTitle>
        <DetailAmountTitle data-testid='confirm-pay-commission-amount'>
          {getSum(commission?.commissionAmount)} {CURRENCY}
        </DetailAmountTitle>
      </DetailBlock>

      {amount ? (
        <>
          {featureFlags.new_form_of_tinkoff_balance_replenishment ? (
            <NewTinkoffPay
              amount={amount}
              supportsQr={commission?.supportsQr}
            />
          ) : (
            <TinkoffPay amount={amount} />
          )}
        </>
      ) : (
        <div>Укажите сумму пополнения</div>
      )}
    </DrawerComponent>
  )
}
